var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 17.541,
    viewBox: "0 0 20 17.541",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.26,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--photon-product-gradient-start)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--photon-product-secondary)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(-22 -164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(-4.36 -3.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M17.7,0H0V11.475l9.35.706,4.615,3.063V12.181l3.739-.706Z",
    transform: "translate(27.671 168.866)",
    fill: "var(--photon-product-soft)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline",
    d: "M19.037,8.375H5.465A3.211,3.211,0,0,0,2.25,11.551v7.656a3.211,3.211,0,0,0,3.213,3.178h7.245l4.085,3.367a.721.721,0,0,0,.76.1.706.706,0,0,0,.411-.64V22.385h1.072a3.211,3.211,0,0,0,3.215-3.176V11.553A3.211,3.211,0,0,0,19.037,8.375ZM5.465,20.973a1.787,1.787,0,0,1-1.786-1.768V11.553A1.787,1.787,0,0,1,5.466,9.787H19.034a1.787,1.787,0,0,1,1.788,1.768v7.652a1.787,1.787,0,0,1-1.788,1.766H17.25a.71.71,0,0,0-.714.706V23.7l-3.012-2.483a1.08,1.08,0,0,0-.687-.246Z",
    transform: "translate(24.11 159.425)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    "data-name": "Layer 3",
    d: "M10.733,5.444H8.957l.413-2.073a.272.272,0,1,0-.533-.1L8.413,5.444H6.229l.413-2.073a.272.272,0,1,0-.533-.1L5.685,5.444H3.8a.268.268,0,0,0,0,.536H5.579L5.152,8.122H3.267a.268.268,0,0,0,0,.536H5.043l-.413,2.073a.268.268,0,0,0,.211.313.181.181,0,0,0,.053,0,.267.267,0,0,0,.267-.214l.427-2.172H7.771l-.413,2.073a.268.268,0,0,0,.211.313.165.165,0,0,0,.051,0,.267.267,0,0,0,.267-.214l.429-2.172H10.2a.268.268,0,0,0,0-.536H8.421L8.851,5.98h1.883a.268.268,0,0,0,0-.536ZM7.877,8.122H5.693L6.123,5.98H8.307Z",
    transform: "translate(25 163.954)",
    fill: "var(--photon-product-spark-detail)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Spark.b570e1d2655094549119c4ee70b2963a.svg";